import { createTheme } from '@mui/material/styles';

const ACCENT = '#FAFF69';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: ACCENT, contrastText: '#0B0B0E' },
    secondary: { main: '#A78BFA' },
    background: {
      default: '#0B0B0E',
      paper: '#15151A',
    },
    text: {
      primary: '#FFFFFF',
      secondary: 'rgba(255,255,255,0.65)',
      disabled: 'rgba(255,255,255,0.4)',
    },
    divider: 'rgba(255,255,255,0.08)',
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Pretendard"',
      '"Noto Sans KR"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: { fontWeight: 800, letterSpacing: '-0.02em' },
    h2: { fontWeight: 800, letterSpacing: '-0.02em' },
    h3: { fontWeight: 700, letterSpacing: '-0.01em' },
    button: { textTransform: 'none', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
});

export default theme;
